import { render, staticRenderFns } from "./goodsLabelsMerge.vue?vue&type=template&id=d666ae6e&scoped=true&"
import script from "./goodsLabelsMerge.vue?vue&type=script&lang=js&"
export * from "./goodsLabelsMerge.vue?vue&type=script&lang=js&"
import style0 from "./goodsLabelsMerge.vue?vue&type=style&index=0&id=d666ae6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d666ae6e",
  null
  
)

component.options.__file = "goodsLabelsMerge.vue"
export default component.exports